<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header @change="_search" hint="External" />
            <div class="content">
                <div class="container">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Bridging Mapping Data</h2>
                                <button class="btn btn-outline-primary" v-html="ic('download') + ' Download Template'" @click="_downloadTemplate"></button>
                            </div>
                            <div class="col-auto">
                                <div class="row">
                                    <div class="col-auto p-0">
                                        <div class="input-icon">
                                            <span class="input-icon-addon">
                                                <i class="fe fe-align-left"></i>
                                            </span>
                                            <select
                                                class="form-control"
                                                v-model="paginate.perPage" 
                                                @change=" paginate.currentPage = 1; _get();"
                                                :disabled="loading">
                                                <option :value="num" v-for="(num, i) in [10, 50, 100, 999]" :key="i"
                                                    v-html="num == 999 ? 'Semua' : num" />
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col p-0">
                                        <button class="btn btn-primary" @click="_add" v-html="ic('plus') + 'Tambah'" />
                                    </div>
                                    <div class="col p-0">
                                        <button class="btn btn-primary" @click="_import" v-html="ic('upload') + 'Import'" />
                                    </div>
                                    <div class="col p-0 pl-2">
                                        <button class="btn btn-outline-primary" :disabled="this.data.length < 0"  @click="_createExcel" v-html="ic('download') + 'Export'" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Skeleton type="table" :length="10" class="mt-3 bg-white" v-if="loading" />

                    <Nodata v-if="!loading && data.length == 0" />

                    <div class="box" v-if="!loading && data.length > 0">
                        <div class="card">
                            <div class="table-responsive">
                                <table class="
                    table table-hover table-vcenter table-striped table-control
                    card-table
                  ">
                                    <thead>
                                        <tr class="text-muted">
                                            <th>No</th>
                                            <th>External</th>
                                            <th>Twin</th>
                                            <th>Type</th>
                                            <th>Vendor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, i) in filter" :key="i">
                                            <td>{{ i + paginate.fromPage }}</td>
                                            <td>{{ row.external }}</td>
                                            <td>{{ row.internal }}</td>
                                            <td>{{ row.type }}</td>
                                            <td>{{ row.vendor }}</td>
                                            <td class="p-0 pos-relative">
                                                <div class="btn-group option center">
                                                    <button class="btn btn-white btn-pill" @click="_edit(row)"
                                                        v-html="ic('edit')" />
                                                    <button class="btn btn-white btn-pill text-danger"
                                                        @click="_delete(row.id)" v-html="ic('trash')" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <b-pagination v-if="data.length > 0 && !loading" align="center" class="mt-5"
                        :total-rows="paginate.totalRows" v-model="paginate.currentPage" :per-page="paginate.perPage"
                        @change="_pageChange" />
                </div>
            </div>
        </div>

        <ImportMapping :config.sync="formImport.config" :initData="formImport.data" :dismiss.sync="formImport.dismiss"
            :isSubmit.sync="formImport.isSubmit" @submit="formImport.action" />

        <FormMapping :config.sync="form.config" :initData="form.data" :dismiss.sync="form.dismiss"
            :isSubmit.sync="form.isSubmit" @submit="form.action" />

        <Confirm :id.sync="confirm.id" :title.sync="confirm.title" :isSubmit.sync="confirm.isSubmit"
            @submit="confirm.action" />
    </div>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormMapping from "./modals/form-mapping.vue";
import ImportMapping from "./modals/import-mapping.vue";

export default {
    name: "BridgingMappingData",
    components: { FormMapping, ImportMapping },

    data() {
        return {
            auth: {},

            formImport: {
                config: { view: false, title: null },
                data: null,
                isSubmit: false,
                action: () => { },
            },

            form: {
                config: { view: false, title: null },
                data: null,
                isSubmit: false,
                action: () => { },
            },

            confirm: {
                id: null,
                title: null,
                isSubmit: false,
                action: () => { },
            },

            loading: true,
            data: [],
            filter: [],

            paginate: {
                currentPage: 1,
                totalRows: 0,
                perPage: 10,
                fromPage: 0,
            },

            dataFilter: {
                keyword: "",
            },
        };
    },

    mixins: [helper],

    methods: {
        _get(params) {
            this.loading = params == null ? true : !params.silent;

            this.axios.get("external_app/bridging?per_page=" + this.paginate.perPage +
                    "&page=" +
                    this.paginate.currentPage +
                    "&keyword=" +
                    this.dataFilter.keyword
                )
                .then((res) => {
                    this.loading = false;

                    this.paginate.totalRows = res.data.meta.total;
                    this.paginate.fromPage = res.data.meta.from;
                    this.data = this.filter = res.data.data;
                })
                .catch((err) => {
                    this.loading = false;
                    this.onError(err);
                });
        },

        _import() {
            this.formImport.config = { view: true, title: "Import Data" };
            this.formImport.data = null;
            this.formImport.action = (importData) => {
                this.axios.post("external_app/bridging/import", importData)
                    .then((res) => {
                        this._get({ silent: true });
                        this.toast(res.data.message);
                        this.formImport.config.view = false;
                    })
                    .catch((err) => {
                        this.onError(err);
                        this.formImport.isSubmit = false;
                    });
            };
        },

        _add() {
            this.form.config = { view: true, title: "Tambah Data" };
            this.form.data = null;
            this.form.action = (formData) => {
                this.axios.post("external_app/bridging", formData)
                    .then((res) => {
                        this._get({ silent: true });
                        this.toast(res.data.message);
                        this.form.config.view = false;
                    })
                    .catch((err) => {
                        this.onError(err);
                        this.form.isSubmit = false;
                    });
            };
        },

        _edit(data) {
            this.form.config = { view: true, title: "Edit Data" };
            this.form.data = data;
            this.form.action = (formData) => {
                this.axios.put("external_app/bridging/" + data.id, formData)
                    .then((res) => {
                        this._get({ silent: true });
                        this.toast(res.data.message);
                        this.form.config.view = false;
                    })
                    .catch((err) => {
                        this.onError(err);
                        this.form.isSubmit = false;
                    });
            };
        },

        _delete(id) {
            this.confirm.id = id;
            this.confirm.title = "Yakin ingin menghapus data ini?";
            this.confirm.action = () => {
                this.axios
                    .delete("external_app/bridging/" + id)
                    .then((res) => {
                        this.toast(res.data.message);
                        this._get({ silent: true });
                        this.confirm.id = null;
                    })
                    .catch((err) => {
                        this.onError(err);
                        this.confirm.isSubmit = false;
                    });
            };
        },

        _pageChange(page) {
            this.paginate.currentPage = page;
            this._get();
        },

        _search(keyword) {
            this.dataFilter.keyword = keyword;
            this._get();
        },

        _downloadTemplate() {
            let data_excel = [{
                "external": '',
                "twin": '',
                "type": '',
                "vendor": '',
            }]
            this.createExcel({
                data: data_excel,
                filename: "template_import_bridging_mapping_external"
            });
        },
        _createExcel(){
            const dataBridging = this.data
            if(dataBridging.length > 0 ){
                let datas = []
                dataBridging.forEach((bridging, key) => {
                    datas.push({
                        no:++key,
                        external:bridging.external,
                        twin:bridging.internal,
                        type:bridging.type,
                        vendor:bridging.vendor,
                    })
                })
                this.createExcel({
                    data: datas,
                    filename: "Bridging Mapping Data - " + this.dTime("datetime"),
                });
            } 
          
        }
    },

    mounted() {
        this.auth = JSON.parse(localStorage.user);
        this._get();
    },
};
</script>
